import { Check, Checkbox, DefaultButton, FontWeights, IBasePickerSuggestionsProps, IButtonStyles, IconButton, IIconProps, IInputProps, ITag, mergeStyleSets, MessageBar, Modal, PrimaryButton, Stack, TagPicker, TextField, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IUserListItem } from '../../../../../Models/Admin/IUserListItem';
import { IAddEventTeacher } from '../../../../../Models/Event/IAddEventTeacher';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IUserTag } from './AddTeacherToEvent';

interface IAddTeacherToEventViewProps {
    eventId: number;
    save: (eventId: number, teacher?: IAddEventTeacher) => void;
    onDismiss: () => void;
    find: (text: string) => PromiseLike<IUserTag[]>;
    isOpened: boolean;
    teacher?: IAddEventTeacher;
    propertyChanged : (key: string, value: any) => void;
    setSelectedItems: (items: ITag[]) => void;
    selectedItems: ITag[];
    statusMessage?: IStatusMessage;
}

export const AddTeacherToEventView: React.FunctionComponent<IAddTeacherToEventViewProps> = (props) => {

    const [last, setLast] = React.useState<IUserTag[]>([]);
    

    const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Navrhovaní lektoři',
        noResultsFoundText: 'Nebylo nic nalezeno',
        resultsMaximumNumber: 5
    };

    const listContainsTagList = (tag: IUserTag, tagList?: IUserTag[]) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };

    const getTextFromItem = (item: ITag) => item.name;

    const inputProps: IInputProps = {
        onBlur: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onBlur called'),
        onFocus: (ev: React.FocusEvent<HTMLInputElement>) => console.log('onFocus called'),
    };

    const filterSuggestedTags = async (filterText: string, tagList?: ITag[]): Promise<IUserTag[]> => {
        var items = await props.find(filterText);
        setLast(items);
        return items;
    }

    const onEmptyInputFocus = (selectedItems?: any[]) => {
        return last;
    }

    const titleId = useId('title');
    const theme = useTheme();


    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };


    return (<Modal
        titleAriaId={titleId}
        isOpen={props.isOpened}
        onDismiss={props.onDismiss}
        isBlocking={false}
        containerClassName={contentStyles.container}>
        <div className={contentStyles.header}>
            <span id={titleId}>Přidání nového lektora</span>
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Zavři"
                onClick={props.onDismiss}/>
        </div>
        <div className={contentStyles.body}>
            <Stack tokens={{ childrenGap:15 }}>
            <TagPicker
                removeButtonAriaLabel="Odebrat"
                onEmptyInputFocus={onEmptyInputFocus}
                selectionAriaLabel="Vybraný zákazník"
                onResolveSuggestions={filterSuggestedTags}
                getTextFromItem={getTextFromItem}
                pickerSuggestionsProps={pickerSuggestionsProps}
                resolveDelay={300}
                onChange={items => items && props.setSelectedItems(items)}
                selectedItems={props.selectedItems}
                itemLimit={1}
                inputProps={{
                    ...inputProps,
                    id: 'picker1',
                    placeholder: "Vyhledejte registrovaného uživatele"
                }}
                />
                <TextField key="payment" disabled={props.teacher === undefined} label="Platba za lekci" styles={{ root: { width: 150 } }} value={props.teacher?.payment.toString()} onChange={(e, v) => props.propertyChanged("payment", Number.parseFloat(v?v:"0"))} />
                <Checkbox key="mainTeacher" disabled={props.teacher === undefined} label="Hlavní lektor" checked={props.teacher?.mainTeacher} onChange={(e, checked) => props.propertyChanged("mainTeacher", checked ? checked : false)} />

                {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar>:null }
                </Stack>
        </div>
        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
            <PrimaryButton disabled={props.teacher === undefined} onClick={() => props.save(props.eventId, props.teacher)}>Uložit</PrimaryButton>
            <DefaultButton onClick={props.onDismiss}>Zavřít</DefaultButton>
        </Stack>
    </Modal>)
}
 